// Shown while subscriptionData/noTimeAvailable.insufficientTime is set (the backend sets it when a job
// runs out of minutes). Dismissing clears the flag; the pages' live listeners then hide this.
// Pages that open it themselves (a picked video is longer than the minutes left) pass onClose and
// neededMinutes/remainingMinutes, since no flag is involved.
import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHistory, faTimes } from '@fortawesome/free-solid-svg-icons';
import { doc, setDoc } from 'firebase/firestore';
import { db, auth } from '../../firebase';
import './InsufficientTimePopUp.css';

export const InsufficientTimePopUp = ({ onClose, neededMinutes, remainingMinutes }) => {
  const clearFlag = () => {
    if (onClose) { onClose(); return; }
    setDoc(
      doc(db, 'users', auth.currentUser.uid, 'subscriptionData', 'noTimeAvailable'),
      { insufficientTime: false },
      { merge: true }
    ).catch(() => {});
  };
  const isTooLong = neededMinutes != null && remainingMinutes != null;

  return (
    <div className="insufpop-overlay" onClick={clearFlag}>
      <div className="insufpop-modal" onClick={e => e.stopPropagation()}>
        <div className="insufpop-header">
          <h2>
            <FontAwesomeIcon icon={faHistory} />  
            {isTooLong ? 'Not Enough Minutes' : 'Out of Minutes'}
          </h2>
          <button className="insufpop-close" onClick={clearFlag} aria-label="Close">
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>

        <div className="insufpop-body">
          {isTooLong ? (
            <p>
              This video needs {neededMinutes.toLocaleString()} {neededMinutes === 1 ? 'minute' : 'minutes'}, and you
              have {remainingMinutes.toLocaleString()} left this period.<br/><br/>
              Upgrade for more minutes, or pick a shorter video.
            </p>
          ) : (
            <p>
              You’ve exhausted your video processing minutes for this quota period.<br/><br/>
              Upgrade now to unlock more time and keep processing!
            </p>
          )}
        </div>

        <div className="insufpop-footer">
          <button className="insufpop-btn-cancel" onClick={clearFlag}>
            Maybe Later
          </button>
          <Link to="/settings/plan" className="insufpop-btn-upgrade" onClick={clearFlag}>
            Upgrade Plan
          </Link>
        </div>
      </div>
    </div>
  );
};

export default InsufficientTimePopUp;
